import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { SobDemandaLabelModule } from '../../../../components/sob-demanda/label';
import { CampanhaPipelineCardInfoVigenciaComponent } from './campanha-pipeline-card-info-vigencia.component';

@NgModule({
    imports: [
        SharedModule,
        SobDemandaLabelModule
    ],
    declarations: [
        CampanhaPipelineCardInfoVigenciaComponent
    ],
    exports: [
        CampanhaPipelineCardInfoVigenciaComponent
    ]
})
export class CampanhaPipelineCardInfoVigenciaModule { }
